<template>
  <div class="login-wrap">
    <div class="header_logo">
        <el-image style="cursor:pointer" class="logo" @click="$router.push('/')" :src="logo" fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
        </el-image>
    </div>
    <div class="minddle bgo_image">
        <el-image :src="this.backgrandImage" fit="fill" style="height:100%;width: -webkit-fill-available;" >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
        </el-image>
        <div class="formBox">
              <div class="login_text">登录</div>
              <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
                  <el-form-item prop="username">
                    <el-input type="text" v-model="ruleForm.username" autocomplete="off" placeholder="账号"></el-input>
                  </el-form-item>
                  <el-form-item  prop="password">
                    <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="密码" @keyup.enter.native="enterLogin('ruleForm')"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
                  </el-form-item>
              </el-form>
               <div class="textBox">
                 <a class="passtext" @click="$router.push('/retrievePassword')">找回密码</a>
                  <el-divider direction="vertical"></el-divider>
                 <a class="creatText" @click="$router.push('/register')">立即注册</a>
              </div>
        </div>
    </div>
    <div class="footer_info" v-if="showCopy">
        <p class="text-center" style="line-height: 30px;">{{informations.copyrightInformation}}<br>
          <a :href="informations.icpUrl" target="_blank">{{informations.icp}}</a>
        </p>
    </div>
    <div style="align-items: center; text-align: center;display: flex; justify-content: center;">
      <el-image
        class="copyright_img"
        :src="require('@/assets/img/Nationa_Lemblem.png')"            style="margin-right: 5px;"
      ></el-image>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=46010002001073" rel="noreferrer" target="_blank">琼公网安备46010002001073号</a>
    </div>

    <!-- 弹窗组件 -->
    <el-dialog title="请选择" :visible.sync="merchantDialogVisible" width="40%">
      <el-tabs v-model="activeMerchantTab">
        <el-tab-pane label="经销商" name="dealer" v-if="dealerList.length > 0">
          <el-radio-group v-model="selectedMerchant">
            <div class="merchant-list">
              <div
                v-for="item in dealerList"
                :key="item.merchantId"
                class="merchant-item"
              >
                <el-radio :label="item" border>
                  {{ item.name }}
                </el-radio>
              </div>
            </div>
          </el-radio-group>
        </el-tab-pane>

        <el-tab-pane label="拍卖商" name="auction_merchant" v-if="auctionMerchantList.length > 0">
          <el-radio-group v-model="selectedMerchant">
            <div class="merchant-list">
              <div
                v-for="item in auctionMerchantList"
                :key="item.merchantId"
                class="merchant-item"
              >
                <el-radio :label="item" border>
                  {{ item.name }}
                </el-radio>
              </div>
            </div>
          </el-radio-group>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
    <el-button @click="merchantDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="confirmSelectMerchant">确 定</el-button>
  </span>
    </el-dialog>


  </div>
</template>
<script type="text/ecmascript-6">
import { login,copyRight,setImage,loginPhoneThird, pcMultiLogin, selectMerchant } from "@/api/xunyou";
import { setCookie, getCookie, delCookie } from '../utils/util'
import md5 from 'js-md5'
export default {
  name: 'login',
  data() {
    return {
      logo:"",
      backgrandImage:"",
      indexInfo:{},
      //登录
      ruleForm: {
        //username和password默认为空
        username: '',
        password: '',
        isNotCode: true,
      },
      informations:{},
      //rules前端验证
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      showCopy:false,
      selectedMerchant: null, // 当前选中的经销商对象
      activeMerchantTab: 'dealer', // 默认选中经销商标签页
      merchantList: [],       // 所有可选经销商列表
      merchantDialogVisible: false,
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.$message({
    //   message: '账号密码及验证码不为空即可',
    //   type: 'success'
    // })
    // // 获取图形验证码
    // this.getcode()
    // // 获取存在本地的用户名密码
    // this.getuserpwd()

    // 平台跳转
    if (this.$route.query.username) {
      this.thirdLogin(this.$route.query.username)
    }
    this.getImagelogo()
    this.geTCopyright()
  },
  computed: {
    // 经销商列表 (type 为 'dealer')
    dealerList() {
      return this.merchantList.filter(item => item.type === 'dealer');
    },
    // 拍卖商列表 (type 为 'auction_merchant')
    auctionMerchantList() {
      return this.merchantList.filter(item => item.type === 'auction_merchant');
    }
  },
  // 里面的函数只有调用才会执行
  methods: {
    thirdLogin(username) {
      let data = {
        phone: username,
        orderFrom: 2
      };
      loginPhoneThird(data)
        .then((res) => {
          if (res.code == 0) {
            // 缓存用户个人信息
            this.$store.commit('login',res.data);
            this.$store.commit('thirdLogin');
            this.$store.commit('getUnReadTotal',res.unReadCount);

            localStorage.setItem('userdata', JSON.stringify(res.data))
            this.$router.push({ path: '/' })
            this.$message({
              type: 'success',
              message: '登录成功!'
            });
          }else{
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("登录失败，请稍后再试！");
        });
    },
    // 获取logo
    getImagelogo(){
      setImage().then(res=>{
          if(res.code==0){
            if(res.rows.length!=0){
              this.showCopy = true;
              this.logo = res.rows[0].pcLogo;
              this.backgrandImage=res.rows[0].backgrandImage;
              this.indexInfo = res.rows[0];

            }
          }
        })
    },
    // 获取版权名称
    geTCopyright(){
      copyRight().then(res=>{
        if(res.code==0){
          this.informations = res.rows[0]
          if(this.informations.powstatus==1){
            this.$router.push('/erroPage')
          }else{
             this.$store.commit('getcopyRight',this.informations)
          }
        }
      }).catch(err=>{
        this.$message.error('查询失败,请稍后再试!')
      })
    },
    // 获取用户名密码
    // getuserpwd() {
    //   if (getCookie('user') != '' && getCookie('pwd') != '') {
    //     this.ruleForm.username = getCookie('user')
    //     this.ruleForm.password = getCookie('pwd')
    //     this.rememberpwd = true
    //   }
    // },

    // 回车登录
    enterLogin(){
      this.submitForm()
    },

    //获取info列表
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          pcMultiLogin(this.ruleForm)
              .then((res) => {
                  if (res.code == 0) {
                    // 判断是否有 data 字段且长度 > 0，说明是商户选择场景
                    if (res.data && res.data.length > 0) {
                      this.showMerchantSelector(res.data); // 弹出商户选择框
                    } else {
                      // 正常登录流程
                      this.handleNormalLogin(res);
                    }
                  }else{
                    this.$message.error(res.msg);
                  }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("登录失败，请稍后再试！");
              });
        } else {
          return false
        }
      })
    },
    // 正常登录
    handleNormalLogin(res) {
      const userData = {
        ...res.data,
        currentMerchant: null // 默认无选择
      };

      // 缓存用户个人信息
      this.$store.commit('login',res.data)
      localStorage.setItem('userdata', JSON.stringify(res.data))
      this.$router.push({ path: '/' })
      this.$message({
        type: 'success',
        message: '登录成功!',
        duration: 1500
      });
    },
    // 展示经销商
    showMerchantSelector(list) {
      // 缓存商户列表
      localStorage.setItem('setMerchantList',  JSON.stringify(list));
      this.merchantList = list;
      this.merchantDialogVisible = true;
    },
    // 确认选择经销商
    confirmSelectMerchant() {
      if (!this.selectedMerchant) {
        this.$message.warning('请选择一个商户');
        return;
      }
      const { muid, merchantId, type } = this.selectedMerchant;

      selectMerchant({ muid, merchantId, type }).then(res => {
        if (res.code === 0) {
          // 合并 currentMerchant 字段
          const userData = {
            ...res.data,
            currentMerchant: this.selectedMerchant
          };

          // 提交到 Vuex + localStorage
          this.$store.commit('login', userData);
          localStorage.setItem('userdata', JSON.stringify(userData));

          this.$message({
            type: 'success',
            message: '登录成功!',
            duration: 1500
          });
          this.$router.push('/');
          this.merchantDialogVisible = false;
        } else {
          this.$message.error(res.msg || '切换商户失败');
        }
      });
    }
  }
}
</script>

<style scoped lang='less'>
.minddle {
    min-width: 100%;
    min-height: 50%;
}
/deep/ .logo img{
  width: 255px;
  height: 52px;
}

.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  .header_logo {
      padding: 30px 140px;
      margin: auto;
  }
  .minddle{
    // background: url("~@/assets/img/registerBackground.png") no-repeat;
    // position: relative;
    // background-repeat: no-repeat;
    // background-size: cover;
    // height: 530px;
    .formBox {
      //  width: 20%;
      width: 450px;
       background: white;
       position: absolute;
       right: 180px;
       top: 15%;
       padding: 25px 45px;
       .login_text {
         color: #666;
         margin-bottom: 20px;
         color: rgba(151, 152, 152, 0.6);
         font-size: 20px;
      }
      button.el-button.el-button--primary {
          width: 100%;
          background-color: #394af8;
          border-color: #394af8;
      }
      button.el-button.el-button--primary:hover{
          background-color: #409eff;
          border-color: #409eff;
      }
      .textBox {
          text-align: right;
          font-size: 16px;
          a{
            color: #68b828;
            cursor: pointer;
          }
      }
    }
  }
  .footer_info {
    text-align: center;
    font-size: 14px;
    padding: 20px;
    p.text-center {
        color: #979898;
    }
  }
}
.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}
.merchant-list {
  display: flex;
  flex-wrap: wrap; /* 自动换行 */
  gap: 10px;       /* 选项之间间距 */
}

.merchant-item {
  display: inline-block;
  margin-bottom: 10px;

  .el-radio {
    padding: 12px;
    border-radius: 4px;
    &:hover {
      background-color: #f5f7fa;
    }
  }
}
/deep/ .el-radio.is-bordered.is-checked {
  border-color: #409eff;
  background-color: #f5f7fa;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #409eff !important;
}

/deep/ .el-radio__inner:hover {
  border-color: #409eff;
}

.copyright_img {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue